import type {AdjustmentDetail, LoanFieldAdjustments} from '@/services/auditService/interface/wp-row';

/** Sum signed adjustment amounts from a loan field adj list (currAdj / nonCurrAdj / inAdj). */
export function sumLoanFieldAdjList(list?: AdjustmentDetail[] | null): number {
    if (!Array.isArray(list) || list.length === 0) return 0;
    return list.reduce((sum, a) => sum + (Number(a?.adjustment) || 0), 0);
}

export function getLoanRowFieldAdj(
    adjustments: LoanFieldAdjustments | null | undefined,
    field: 'currAdj' | 'nonCurrAdj' | 'inAdj',
): AdjustmentDetail[] | undefined {
    const list = adjustments?.[field];
    return Array.isArray(list) && list.length > 0 ? list : undefined;
}

/**
 * LoanFieldAdjustPanel Item label by fromPaper code
 * (text before code=… in BankLoan / VehicleLoan field-adjust mapping).
 */
export const LOAN_FIELD_ADJ_ITEM_NAME_BY_CODE: Record<string, string> = {
    'BS-CL-BLS': 'Bank loan, secured',
    'BS-NCL-BLS': 'Bank loan, secured',
    'BS-CL-OFL': 'Obligation under finance lease',
    'BS-NCL-OFL': 'Obligation under finance lease',
    'PL-FC-LI': 'Loan interest expenses',
};

/** Resolve CommonTable item name for loan field adjustment. */
export function resolveLoanFieldAdjItemName(code: string, fallback?: string): string {
    const key = String(code || '').trim().toUpperCase();
    return LOAN_FIELD_ADJ_ITEM_NAME_BY_CODE[key]
        || String(fallback || '').trim()
        || 'Adjustment';
}
